import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  ${({ theme }) => `
  background: ${theme.colors.neutral.primary[5]};
`}
`;
